// extracted by mini-css-extract-plugin
export default {"button":"PaginationButton_button__GnYy6","icon":"PaginationButton_icon__9Zbm1"};